import React, { useState } from 'react';
import styles from './bottomNav.module.css';

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { sidebarAction } from "../../ReduxStore/sideBarState";
import dashboardIcon from '../../Assest/img/dashboardIcon (1).svg';
import inquiryIcon from '../../Assest/img/inquiryIcon.svg';
import interestedVendorIcon from '../../Assest/img/interestedVendorIcon.svg';
import dashbordActiveIcon from '../../Assest/img/dashboardActiveicon.svg';
import inquiryActiveIcon from '../../Assest/img/inquiryActiveIcon.svg';
import interestedVendorActiveIcon from '../../Assest/img/interestedVendorActiveIcon.svg';

function BottomNav() {

    const activeTab = useSelector((state) => state.sidebar?.activeTab ?? 'dashboard');
    const [hovered, setHovered] = useState([false, false, false, false]); 
    const navigate = useNavigate();
    const dispatch = useDispatch();


    const handleActiveTab = (e, tab ,route) => {
        e.preventDefault();
        dispatch(sidebarAction.selectActiveTab(tab));
        navigate(route)
    };

    const handleMouseEnter = (index) => {
        setHovered(hovered.map((_, i) => i === index));
    };

    const handleMouseLeave = () => {
        setHovered([false, false, false, false]); 
    };


  return (
    <div className={styles.container}>
        
      {/* <div className={`${styles.dashbord} 
                        ${(hovered[3] || activeTab === 'inquiry') ? 'bg-[#600AAD] text-white' : 'text-[#600AAD]'}`}
                    onClick={(e) => handleActiveTab(e, 'inquiry','/category')}
                    onMouseEnter={() => handleMouseEnter(3)}
                    onMouseLeave={handleMouseLeave}
                >
                    <img
                        src={(hovered[3] || activeTab === 'inquiry') ? inquiryActiveIcon : inquiryIcon}
                        alt="inquiry icon"
                        className="w-5 h-5  ml-2 mx-3"
                    />
                    <Link className={` ${(hovered[3] || activeTab === 'inquiry') ? 'text-white' : 'text-[#600AAD]'}`} to="/category">
                        Inquiry
                    </Link></div>  */}
          
          <div
          className={`${styles.dashbord}
                        ${(hovered[1] || activeTab === 'Dashboard') ? 'bg-[#600AAD] text-white' : 'text-[#600AAD]'}`}
                    onClick={(e) => handleActiveTab(e, 'Dashboard','/Dashboard')}
                    onMouseEnter={() => handleMouseEnter(1)}
                    onMouseLeave={handleMouseLeave}
                >
                    <img
                        src={(hovered[1] || activeTab === 'Dashboard') ? dashbordActiveIcon : dashboardIcon}
                  alt="Dashboard icon"
                  className="w-5 h-5  ml-2 mx-3"

                    />
                    <Link className={` ${(hovered[1] || activeTab === 'Dashboard') ? 'text-white' : 'text-[#600AAD]'}`} to="/Dashboard">
                        Dashboard
                    </Link>
          </div>
          
         
          
      <div className={`${styles.dashbord}
                        ${(hovered[2] || activeTab === 'interestedVendor') ? 'bg-[#600AAD] text-white' : 'text-[#600AAD]'}`}
                    onClick={(e) => handleActiveTab(e, 'interestedVendor','/interestedVendor')}
                    onMouseEnter={() => handleMouseEnter(2)}
                    onMouseLeave={handleMouseLeave}
                >
                    <img
                        src={(hovered[2] || activeTab === 'interestedVendor') ? interestedVendorActiveIcon : interestedVendorIcon}
                        alt="interestedVendor icon"
                        className="w-5 h-5 ml-3 mx-3 "
                    />
                    <Link className={` ${(hovered[2] || activeTab === 'interestedVendor') ? 'text-white' : 'text-[#600AAD]'}`} to="/interestedVendor">
                        interestedVendor 
              </Link>
          </div>

    </div>
  )
}

export default BottomNav
